export const SHORTLIST_ADDED_EVENT = 'shortlist-added-notification';
export const SHORTLIST_REMOVED_EVENT = 'shortlist-removed-notification';

function propertyAddress(property) {
  return (
    property.addressShort ||
    property.propertyName ||
    property.street ||
    property.name ||
    'Property'
  );
}

export function showShortlistAddedNotification(property = {}) {
  window.dispatchEvent(
    new CustomEvent(SHORTLIST_ADDED_EVENT, {
      detail: {
        address: propertyAddress(property),
      },
    })
  );
}

export function showShortlistRemovedNotification(property = {}, undo) {
  window.dispatchEvent(
    new CustomEvent(SHORTLIST_REMOVED_EVENT, {
      detail: {
        address: propertyAddress(property),
        undo,
      },
    })
  );
}
